// extracted by mini-css-extract-plugin
export default {"fr-view":"Editor_fr-view__acpsK","header":"Editor_header__8z717","title":"Editor_title__3c5VJ","count":"Editor_count__Tr4ub","warning":"Editor_warning__nGDfn"};